import {gql} from '@apollo/client';

export const GetInstitutionSettings = gql`
    query GetInstitutionSettings($institutionId: InstitutionId!) {
        institutions(institutionId: $institutionId) {
            id: institutionId
            title
            profileImage {
                url
            }
            settings {
                settingGroups {
                    title
                    groups {
                        status
                        subtitle {
                            label
                            status
                        }
                        title
                        __typename
                    }
                }
            }
            behaviors {
                behaviorId
            }
        }
    }
`;
